/* ============================================================
   AOT KATALOG · Gesamtsortiment – progressive Erweiterung
   Datei: assets/aot-katalog.js
   Gehört zu: sections/aot-katalog-sortiment.liquid

   Ohne JavaScript bleibt das komplette Register sichtbar, die A–Z-
   Leiste funktioniert über Anker und die Suche geht an die Shopify-
   Suche. Dieses Skript ergänzt Live-Suche, Sektor-/Gruppenfilter,
   Ansichtswechsel und hält den Zustand in der URL:
   ?suche=…&sektor=kosmetik|lebensmittel&gruppe=<typ-handle>&ansicht=liste|karten
   ============================================================ */
(() => {
  const PARAM = { q: 'suche', sector: 'sektor', type: 'gruppe', view: 'ansicht' };
  const VIEWS = ['liste', 'karten'];

  const norm = (value) =>
    (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[®™©]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

  const compact = (value) => value.replace(/[\s\-–./,]/g, '');

  function init(root) {
    if (!root || root.dataset.aotKatReady) return;
    root.dataset.aotKatReady = 'true';
    root.classList.add('aot-kat--js');

    const items = Array.from(root.querySelectorAll('[data-kat-item]'));
    if (!items.length) return;

    const groups = Array.from(root.querySelectorAll('[data-kat-group]'));
    const form = root.querySelector('[data-kat-form]');
    const input = root.querySelector('[data-kat-search]');
    const clearBtn = root.querySelector('[data-kat-clear]');
    const sectorBtns = Array.from(root.querySelectorAll('[data-kat-sector]'));
    const typeBtns = Array.from(root.querySelectorAll('[data-kat-type]'));
    const viewBtns = Array.from(root.querySelectorAll('[data-kat-view]'));
    const letterLinks = Array.from(root.querySelectorAll('[data-kat-letter]'));
    const countEl = root.querySelector('[data-kat-count]');
    const emptyEl = root.querySelector('[data-kat-empty]');
    const resetBtns = Array.from(root.querySelectorAll('[data-kat-reset]'));
    const countTpl = countEl ? countEl.dataset.template || '' : '';
    const total = items.length;

    items.forEach((item) => {
      const hay = norm(item.dataset.search);
      item._hay = hay;
      item._hayCompact = compact(hay);
      item._sectors = (item.dataset.sector || '').split(' ').filter(Boolean);
      item._type = item.dataset.type || '';
    });

    const validSectors = ['alle'].concat(sectorBtns.map((b) => b.dataset.katSector));
    const validTypes = ['alle'].concat(typeBtns.map((b) => b.dataset.katType));

    const params = new URLSearchParams(window.location.search);
    const state = {
      q: params.get(PARAM.q) || '',
      sector: params.get(PARAM.sector) || 'alle',
      type: params.get(PARAM.type) || 'alle',
      view: params.get(PARAM.view) || root.dataset.defaultView || 'liste',
    };
    if (!validSectors.includes(state.sector)) state.sector = 'alle';
    if (!validTypes.includes(state.type)) state.type = 'alle';
    if (!VIEWS.includes(state.view) || !viewBtns.length) state.view = root.dataset.defaultView || 'liste';
    if (input) input.value = state.q;

    const terms = () => norm(state.q).split(' ').filter(Boolean);

    function match(item, t, ignore) {
      if (ignore !== 'sector' && state.sector !== 'alle' && !item._sectors.includes(state.sector)) return false;
      if (ignore !== 'type' && state.type !== 'alle' && item._type !== state.type) return false;
      for (const term of t) {
        if (item._hay.includes(term)) continue;
        const c = compact(term);
        if (c.length > 1 && item._hayCompact.includes(c)) continue;
        return false;
      }
      return true;
    }

    function syncUrl() {
      const url = new URL(window.location.href);
      const set = (key, value, fallback) => {
        if (value && value !== fallback) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      };
      set(PARAM.q, state.q.trim(), '');
      set(PARAM.sector, state.sector, 'alle');
      set(PARAM.type, state.type, 'alle');
      set(PARAM.view, state.view, root.dataset.defaultView || 'liste');
      window.history.replaceState(window.history.state, '', url);
    }

    function render() {
      const t = terms();
      let shown = 0;

      items.forEach((item) => {
        const ok = match(item, t);
        item.hidden = !ok;
        if (ok) shown += 1;
      });

      groups.forEach((group) => {
        const visible = group.querySelectorAll('[data-kat-item]:not([hidden])').length;
        group.hidden = visible === 0;
        const n = group.querySelector('[data-kat-group-n]');
        if (n) n.textContent = visible;
      });

      letterLinks.forEach((link) => {
        const group = root.querySelector('[data-kat-group="' + link.dataset.katLetter + '"]');
        const off = !group || group.hidden;
        link.classList.toggle('is-disabled', off);
        if (off) link.setAttribute('aria-disabled', 'true');
        else link.removeAttribute('aria-disabled');
        link.tabIndex = off ? -1 : 0;
      });

      sectorBtns.forEach((btn) => {
        const key = btn.dataset.katSector;
        btn.setAttribute('aria-pressed', String(key === state.sector));
        const n = btn.querySelector('[data-kat-n]');
        if (n) {
          n.textContent = items.filter((item) => item._sectors.includes(key) && match(item, t, 'sector')).length;
        }
      });

      typeBtns.forEach((btn) => {
        const key = btn.dataset.katType;
        btn.setAttribute('aria-pressed', String(key === state.type));
        if (key === 'alle') return;
        const n = items.filter((item) => item._type === key && match(item, t, 'type')).length;
        const nEl = btn.querySelector('[data-kat-n]');
        if (nEl) nEl.textContent = n;
        btn.hidden = n === 0 && key !== state.type;
      });

      viewBtns.forEach((btn) => btn.setAttribute('aria-pressed', String(btn.dataset.katView === state.view)));
      root.dataset.view = state.view;

      if (countEl && countTpl) countEl.textContent = countTpl.replace('__S__', shown).replace('__T__', total);
      if (emptyEl) emptyEl.hidden = shown > 0;
      if (clearBtn) clearBtn.hidden = !state.q;

      syncUrl();
    }

    let timer;
    if (input) {
      input.addEventListener('input', () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => {
          state.q = input.value;
          render();
        }, 120);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && input.value) {
          event.preventDefault();
          input.value = '';
          state.q = '';
          render();
        }
      });
    }

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        state.q = input ? input.value : '';
        render();
        const first = root.querySelector('[data-kat-item]:not([hidden]) a');
        if (first) first.focus({ preventScroll: false });
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        if (input) {
          input.value = '';
          input.focus();
        }
        state.q = '';
        render();
      });
    }

    sectorBtns.forEach((btn) =>
      btn.addEventListener('click', () => {
        state.sector = btn.dataset.katSector;
        render();
      })
    );

    typeBtns.forEach((btn) =>
      btn.addEventListener('click', () => {
        state.type = btn.dataset.katType === state.type ? 'alle' : btn.dataset.katType;
        render();
      })
    );

    viewBtns.forEach((btn) =>
      btn.addEventListener('click', () => {
        state.view = btn.dataset.katView;
        render();
      })
    );

    resetBtns.forEach((btn) =>
      btn.addEventListener('click', () => {
        state.q = '';
        state.sector = 'alle';
        state.type = 'alle';
        if (input) input.value = '';
        render();
        if (input) input.focus();
      })
    );

    letterLinks.forEach((link) =>
      link.addEventListener('click', (event) => {
        if (link.classList.contains('is-disabled')) event.preventDefault();
      })
    );

    render();
  }

  const boot = (scope) => (scope || document).querySelectorAll('[data-aot-katalog]').forEach(init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
